import { array, string, object } from 'yup'
import { safify } from '../utils/safify'
import { isUrl } from './utils'

export const validLinks = array()
  .of(
    object({
      url: string()
        .test('is-url', 'Invalid Link', (value) => {
          if (!value) return true
          return isUrl(value)
        })
        .default('')
        .nullable(),
    }),
  )
  .transform(safify)
